export const supportedLanguages = {
  es: 'Español',
  en: 'English'
}
